import { NgModule, ModuleWithProviders} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '@vfde-fe/ngx-lib/services/user';
import { SubscriptionService } from '@vfde-fe/ngx-lib/services/subscription';
import { ContractService } from '@vfde-fe/ngx-lib/services/contract';
import { StorageService } from '@vfde-fe/ngx-lib/services/storage';
import { RoutesCachingService } from '@vfde-fe/ngx-lib/services/routes-caching';
import { AuthModule } from './auth.module';
import { RoutesUtilsService } from '@vfde-fe/ngx-lib/services/routes-utils';
import { NbaService } from '@vfde-fe/ngx-lib/services/nba';
import { ConfirmDataLossService } from '@vfde-fe/ngx-lib/services/confirm-data-loss';
import { CustomErrorHandlerService } from '@vfde-fe/ngx-lib/services/custom-error-handler';
import { DetectDataLossService } from '@vfde-fe/ngx-lib/services/detect-data-loss';
import { BewService } from '@vfde-fe/ngx-lib/services/bew-transaction';
import { PaymentService } from '@vfde-fe/ngx-lib/plugins/payment';
import { TariffService } from '@vfde-fe/ngx-lib/services/tariff';
import { CallbackService } from '@vfde-fe/ngx-lib/components/callback';
import { UnbilledUsageService } from '@vfde-fe/ngx-lib/services/unbilledusage';
import { UpsellingService } from '@vfde-fe/ngx-lib/services/upselling';
import { ContractSummaryService } from '@vfde-fe/ngx-lib/components/new-contract-summary';
import { DslContractService } from '@vfde-fe/ngx-lib/services/dsl-contract';
import { CpmSharedService } from '@vfde-fe/ngx-lib/services/cpm-shared';
import { ContactDataService } from '@vfde-fe/ngx-lib/services/contact-data';
import { AddressSharedService } from '@vfde-fe/ngx-lib/services/address-shared';
import { Helper } from '@vfde-fe/ngx-lib/services/helper-utils';
import { CableProductsCacheService } from '@vfde-fe/ngx-lib/services/cable-products-cache';
import { CableProductsService } from '@vfde-fe/ngx-lib/services/cable-products';


/** modules  */

@NgModule({
    imports: [CommonModule , AuthModule.forRoot()],
})
/** coreModule */
export class CoreModule {
  /* eslint-disable */
    public static forRoot (): ModuleWithProviders<any> {
        return {
            ngModule: CoreModule,
            providers: [
                Helper,
                RoutesUtilsService,
                StorageService,
                RoutesCachingService,
                UserService,
                SubscriptionService,
                ContractService,
                DslContractService,
                NbaService,
                CustomErrorHandlerService,
                ConfirmDataLossService,
                DetectDataLossService,
                BewService,
                PaymentService,
                TariffService,
                CpmSharedService,
                CallbackService,
                UnbilledUsageService,
                ContactDataService,
                AddressSharedService,
                UpsellingService,
                ContractSummaryService,
                CableProductsService,
                CableProductsCacheService,

            ],
        };
    }
}
